// 统计页面PV和UV
export const PVUV = {
  setPVUV (url) {
  }
}
